import { Action } from 'redux';
import { Page } from '../../../api/api.types';
import { ItemPriceFilters, ItemPriceModel } from '../../../api/pricing/pricing.types';

export const GET_ITEM_PRICE_LIST = 'GET_ITEM_PRICE_LIST';
export const GET_ITEM_PRICE = 'GET_ITEM_PRICE';
export const POST_ITEM_PRICE = 'POST_ITEM_PRICE';
export const PUT_ITEM_PRICE = 'PUT_ITEM_PRICE';
export const DELETE_ITEM_PRICE = 'DELETE_ITEM_PRICE';
export const UPDATE_ITEM_PRICE_FILTERS = 'UPDATE_ITEM_PRICE_FILTERS';

export interface GetItemPriceListAction extends Action {
  type: typeof GET_ITEM_PRICE_LIST;
  payload: {
    page: Page<ItemPriceModel>;
  };
}

export interface GetItemPriceAction extends Action {
  type: typeof GET_ITEM_PRICE;
  payload: {
    selectedItemPrice: ItemPriceModel | null;
  };
}

export interface PostItemPriceAction extends Action {
  type: typeof POST_ITEM_PRICE;
  payload: {
    success: boolean;
    newItemPrice: ItemPriceModel | null;
  };
}

export interface PutItemPriceAction extends Action {
  type: typeof PUT_ITEM_PRICE;
  payload: {
    selectedItemPrice: ItemPriceModel;
  };
}

export interface DeleteItemPriceAction extends Action {
  type: typeof DELETE_ITEM_PRICE;
  payload: {
    success: boolean;
  };
}

export interface UpdateItemPriceFiltersAction extends Action {
  type: typeof UPDATE_ITEM_PRICE_FILTERS;
  payload: {
    filters: ItemPriceFilters;
  };
}

export interface ItemPriceState {
  itemPrices: ItemPriceModel[] | [];
  selectedItemPrice: ItemPriceModel | null;
  totalElements: number;
  totalPages: number;
  postSuccess: boolean | null;
  lastFetch: number | null;
  filters: ItemPriceFilters | null;
}

export type ItemPriceActionTypes =
  GetItemPriceListAction
  | GetItemPriceAction
  | PostItemPriceAction
  | DeleteItemPriceAction
  | PutItemPriceAction
  | UpdateItemPriceFiltersAction;
